// Pure predicate: did the last turn propose any actions the UI must fetch?
export function shouldFetchPending(responseData) {
  return Number(responseData?.pendingActionsProposed) > 0;
}
